import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { LogOut } from "lucide-react";
import NotificationBell from "./NotificationBell";
import LanguageToggle from "./LanguageToggle";
import { useTranslation } from "react-i18next";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const { t } = useTranslation();

  const isAuthed = user && user.id;

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-black/70 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-2">
          <img
            src="/logo.png"
            alt="AfriGoall"
            className="h-11 md:h-12 w-auto"
            data-testid="nav-logo-img"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold uppercase tracking-widest">
          <Link data-testid="nav-link-messages" to="/messages" className="hover:text-[#e65f2b] transition-colors">{t("nav.messages")}</Link>
          <Link data-testid="nav-link-players" to="/players" className="hover:text-[#e65f2b] transition-colors">{t("nav.players")}</Link>
          <Link data-testid="nav-link-pricing" to="/billing" className="hover:text-[#e65f2b] transition-colors">{t("nav.pricing")}</Link>
          <Link data-testid="nav-link-pathway" to="/#pathway" className="hover:text-[#e65f2b] transition-colors">{t("nav.pathway")}</Link>
          <Link data-testid="nav-link-about" to="/#about" className="hover:text-[#e65f2b] transition-colors">{t("nav.about")}</Link>
        </nav>

        <div className="flex items-center gap-3">
          <LanguageToggle />
          {isAuthed ? (
            <>
              <NotificationBell />
              <Link to="/dashboard" data-testid="nav-dashboard-btn">
                <Button variant="ghost" className="text-white hover:bg-white/10">
                  {user.name?.split(" ")[0]}
                </Button>
              </Link>
              <Button
                data-testid="nav-logout-btn"
                onClick={async () => { await logout(); nav("/"); }}
                variant="outline"
                className="border-white/20 text-white hover:bg-white/10"
              >
                <LogOut size={16} className="mr-2" />{t("nav.logout")}
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn">
                <Button variant="ghost" className="text-white hover:bg-white/10">{t("nav.signIn")}</Button>
              </Link>
              <Link to="/register" data-testid="nav-register-btn">
                <Button className="bg-[#e65f2b] hover:bg-[#c54a1c] text-black font-bold rounded-sm">
                  {t("nav.join")}
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
